import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import {
    HeaderBottom,
    HeaderMobile,
    StickyHeader
} from '@rawlplug/ldp-components';
// import StickyHeader from "./StickyHeader.vue";
import HeaderNavigation from "./HeaderNavigation.vue";
import RawlplugLogo from "../../assets/RawlplugLogo.svg";
import MenuItem from "@/components/TheHeader/MenuItem";
import MobileNavigation from "./MobileNavigation.vue";


@Component({
    // @ts-ignore
    components: {
        StickyHeader,
        HeaderBottom,
        HeaderMobile,
        HeaderNavigation,
        MobileNavigation,
        RawlplugLogo
    }
})
export default class TheHeader extends Vue {
    activeMenuItem: MenuItem = {
        label: "",
        href: "#"
    };
    @Prop() menuItems: MenuItem[] | undefined;
    @Prop() title: string | undefined;
    @Prop() phoneNumber: string  | undefined;


    created() {
        if (this.menuItems && this.menuItems[0]) {
            this.activeMenuItem = this.menuItems[0];
        }
    }
}
